var map = {
	"./circle_black.svg": 435,
	"./circle_blue.svg": 436,
	"./ellipse_black.svg": 437,
	"./france.svg": 262,
	"./highlighted_yellow.svg": 438,
	"./icone/carousel_new.svg": 450,
	"./icons/Cart.svg": 451,
	"./icons/Cart_add.svg": 452,
	"./icons/Cart_delete.svg": 453,
	"./icons/Cart_remove.svg": 454,
	"./icons/_info.svg": 455,
	"./icons/add_icon.svg": 266,
	"./icons/add_prod.svg": 456,
	"./icons/add_prodOLD.svg": 457,
	"./icons/ask.svg": 458,
	"./icons/carousel.svg": 336,
	"./icons/carrello.svg": 459,
	"./icons/categorie.svg": 460,
	"./icons/clear_chart.svg": 461,
	"./icons/close.svg": 189,
	"./icons/close_.svg": 462,
	"./icons/condividi.svg": 463,
	"./icons/email.svg": 338,
	"./icons/facebook.svg": 186,
	"./icons/hatchef.svg": 327,
	"./icons/icone/_info.svg": 464,
	"./icons/icone/book-open-solid.svg": 320,
	"./icons/icone/columns-solid.svg": 321,
	"./icons/icone/file-pdf-solid.svg": 323,
	"./icons/icone/hatchef.svg": 465,
	"./icons/icone/info.svg": 466,
	"./icons/icone/list-solid.svg": 326,
	"./icons/icone/magnifying-glass-solid.svg": 322,
	"./icons/icone/play.svg": 467,
	"./icons/icone/plus.svg": 468,
	"./icons/icone/share-square-solid-prod.svg": 325,
	"./icons/icone/share-square-solid.svg": 324,
	"./icons/icone/specs.svg": 469,
	"./icons/icone/world.svg": 470,
	"./icons/index-icon-bookmark.svg": 471,
	"./icons/index-icon.svg": 472,
	"./icons/info.svg": 335,
	"./icons/informazioni.svg": 473,
	"./icons/internal_link.svg": 339,
	"./icons/mappa.svg": 474,
	"./icons/markers-SVG/ask.svg": 475,
	"./icons/markers-SVG/info.svg": 476,
	"./icons/markers-SVG/list.svg": 477,
	"./icons/markers-SVG/recipe.svg": 478,
	"./icons/markers-SVG/web.svg": 479,
	"./icons/pagine.svg": 480,
	"./icons/pdf.svg": 481,
	"./icons/play.svg": 331,
	"./icons/play_ip.svg": 332,
	"./icons/plus.svg": 328,
	"./icons/plus_ip.svg": 329,
	"./icons/prodotti.svg": 482,
	"./icons/promo.svg": 334,
	"./icons/promo2.svg": 483,
	"./icons/promo3.svg": 484,
	"./icons/promo_10.svg": 485,
	"./icons/promo_classic.svg": 486,
	"./icons/remove_prod.svg": 487,
	"./icons/remove_prodOLD.svg": 488,
	"./icons/remove_prod_.svg": 489,
	"./icons/ricetta.svg": 490,
	"./icons/schermo_intero.svg": 491,
	"./icons/shop_list.svg": 492,
	"./icons/specs.svg": 333,
	"./icons/telephone.svg": 337,
	"./icons/video.svg": 493,
	"./icons/volantino.svg": 494,
	"./icons/whatsapp.svg": 187,
	"./icons/world.svg": 330,
	"./logo_catalog_interattivo.svg": 496,
	"./logo_interattivo.svg": 498,
	"./logo_interattivo_free.svg": 500,
	"./logo_menu_interattivo.svg": 501,
	"./logo_volantinointerattivo_free.svg": 341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1122;